import { shopContentTokensConfig } from './config.js';
import { ShopContentTokens, ShopContentTokenValue } from '../orm/dynamodb/shopContentTokens/types';

export const defaultShopContentTokens: ShopContentTokens = shopContentTokensConfig.tokens.reduce((acc, token) => {
    acc[token.key] = {
        value: token.value,
        meta: token.meta
    } as ShopContentTokenValue;
    return acc;
}, {} as ShopContentTokens); 